import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = { class: "container-fluid py-3 page-main-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col text-center page-main-title" }
const _hoisted_5 = { class: "white-text" }
const _hoisted_6 = { class: "col-md-9 col-lg-10 px-md-4" }
const _hoisted_7 = { class: "container py-3" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6 py-3" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12 text-center text-lg-start py-3" }
const _hoisted_12 = { class: "hc1 bold" }
const _hoisted_13 = { class: "col-12 p-4 bg-grey" }
const _hoisted_14 = { class: "grey-text" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "grey-text" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12 p-4" }
const _hoisted_19 = { class: "grey-text" }
const _hoisted_20 = {
  key: 0,
  class: "row"
}
const _hoisted_21 = { class: "col-12 p-4" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "col-12 p-4" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 1,
  class: "row"
}
const _hoisted_28 = { class: "col-12 p-4" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "col-12 p-4" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "col-12 p-4" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "col-12 p-4" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "col-12 p-4" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = ["src"]
const _hoisted_43 = {
  key: 2,
  class: "row"
}
const _hoisted_44 = { class: "col-12 p-4" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "col-12 p-4" }
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "col-12 p-4" }
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "col-12 p-4" }
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = ["src"]
const _hoisted_56 = {
  key: 3,
  class: "row"
}
const _hoisted_57 = { class: "col-12 p-4" }
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = ["src"]
const _hoisted_60 = { class: "col-12 p-4" }
const _hoisted_61 = ["innerHTML"]
const _hoisted_62 = ["src"]
const _hoisted_63 = { class: "col-12 p-4" }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = ["src"]
const _hoisted_66 = {
  key: 4,
  class: "row"
}
const _hoisted_67 = { class: "col-12 p-4" }
const _hoisted_68 = ["innerHTML"]
const _hoisted_69 = ["src"]
const _hoisted_70 = { class: "col-12 p-4" }
const _hoisted_71 = ["innerHTML"]
const _hoisted_72 = ["src"]
const _hoisted_73 = { class: "col-12 p-4" }
const _hoisted_74 = ["innerHTML"]
const _hoisted_75 = ["src"]
const _hoisted_76 = { class: "col-12 p-4" }
const _hoisted_77 = ["innerHTML"]
const _hoisted_78 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_error_tips = _resolveComponent("error-tips")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString($setup.locale.android10), 1)
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Breadcrumb, {
                class: "grey-text",
                item_one_title: $setup.locale.android11,
                item_one_active: true,
                loading: $setup.data.loading
              }, null, 8, ["item_one_title", "loading"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString($setup.locale.android11), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString($setup.locale.android12), 1),
              _hoisted_15,
              _createElementVNode("span", _hoisted_16, _toDisplayString($setup.locale.android13), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString($setup.locale.android14), 1),
              _createElementVNode("a", {
                href: "/tutorials/android?page=1&p=2",
                onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleMouseOver && $setup.handleMouseOver(...args))),
                onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleMouseLeave && $setup.handleMouseLeave(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass($setup.data.page==1 /* && !data.hover */?'btn-tutorial-tab-title  btn-selected':'btn-tutorial-tab-title')
                }, _toDisplayString($setup.locale.android15), 3)
              ], 32),
              _createElementVNode("a", {
                href: "/tutorials/android?page=2&p=2",
                onMouseover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleMouseOver && $setup.handleMouseOver(...args))),
                onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.handleMouseLeave && $setup.handleMouseLeave(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass($setup.data.page==2 /* && !data.hover */?'btn-tutorial-tab-title  btn-selected':'btn-tutorial-tab-title')
                }, _toDisplayString($setup.locale.android16), 3)
              ], 32),
              _createElementVNode("a", {
                href: "/tutorials/android?page=3&p=2",
                onMouseover: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.handleMouseOver && $setup.handleMouseOver(...args))),
                onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.handleMouseLeave && $setup.handleMouseLeave(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass($setup.data.page==3 /* && !data.hover */?'btn-tutorial-tab-title  btn-selected':'btn-tutorial-tab-title')
                }, _toDisplayString($setup.locale.android17), 3)
              ], 32),
              _createElementVNode("a", {
                href: "/tutorials/android?page=4&p=2",
                onMouseover: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.handleMouseOver && $setup.handleMouseOver(...args))),
                onMouseleave: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.handleMouseLeave && $setup.handleMouseLeave(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass($setup.data.page==4 /* && !data.hover */?'btn-tutorial-tab-title  btn-selected':'btn-tutorial-tab-title')
                }, _toDisplayString($setup.locale.android18), 3)
              ], 32),
              _createElementVNode("a", {
                href: "/tutorials/android?page=5&p=2",
                onMouseover: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.handleMouseOver && $setup.handleMouseOver(...args))),
                onMouseleave: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.handleMouseLeave && $setup.handleMouseLeave(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass($setup.data.page==5 /* && !data.hover */?'btn-tutorial-tab-title  btn-selected':'btn-tutorial-tab-title')
                }, _toDisplayString($setup.locale.android19), 3)
              ], 32)
            ])
          ]),
          ($setup.data.page==1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android20
                  }, null, 8, _hoisted_22),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[0],
                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[0]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_23)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android21
                  }, null, 8, _hoisted_25),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[1],
                    onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[1]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_26)
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.data.page==2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android22
                  }, null, 8, _hoisted_29),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[2],
                    onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[2]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_30)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android23
                  }, null, 8, _hoisted_32),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[3],
                    onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[3]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_33)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android24
                  }, null, 8, _hoisted_35),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[4],
                    onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[4]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_36)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android25
                  }, null, 8, _hoisted_38),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[5],
                    onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[5]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_39)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android26
                  }, null, 8, _hoisted_41),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[6],
                    onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[6]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_42)
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.data.page==3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android27
                  }, null, 8, _hoisted_45),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[7],
                    onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[7]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_46)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android28
                  }, null, 8, _hoisted_48),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[8],
                    onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[8]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_49)
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android29
                  }, null, 8, _hoisted_51),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[9],
                    onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[9]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_52)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android30
                  }, null, 8, _hoisted_54),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[10],
                    onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[10]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_55)
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.data.page==4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android31
                  }, null, 8, _hoisted_58),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[11],
                    onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[11]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_59)
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android32
                  }, null, 8, _hoisted_61),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[12],
                    onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[12]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_62)
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android33
                  }, null, 8, _hoisted_64),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[13],
                    onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[13]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_65)
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.data.page==5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android34
                  }, null, 8, _hoisted_68),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[14],
                    onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[14]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_69)
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android35
                  }, null, 8, _hoisted_71),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[15],
                    onClick: _cache[25] || (_cache[25] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[15]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_72)
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android36
                  }, null, 8, _hoisted_74),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[16],
                    onClick: _cache[26] || (_cache[26] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[16]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_75)
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.android37
                  }, null, 8, _hoisted_77),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[17],
                    onClick: _cache[27] || (_cache[27] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[17]))),
                    alt: "android_tutorial"
                  }, null, 8, _hoisted_78)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_error_tips, { ref: "errorRef" }, null, 512)
  ], 64))
}